/**
 * Moonpage 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

const primaryGradient = brandTheme.primaryGradient || 'linear-gradient(90deg, #8DB8FF 0%, #5E79F6 100%)'

export const theme = {
  homeBg: '',
  tagsBg: '',
  tagActiveBg: brandTheme.primaryColor,
  tagActiveText: brandTheme.textInverse,
  tagInactiveBg: '#EAF1FF',
  tagInactiveText: '#5F77AA',
  tabActiveGradient: `linear-gradient(270deg, ${brandTheme.bgGlobal} 0%, ${brandTheme.primaryColor} 95%)`,
  tabActiveColor: brandTheme.textPrimary,
  stickyHeaderBg: brandTheme.bgGlobal,
  primaryGradient,
  tabBorderColor: 'rgba(76, 125, 255, 0.12)',
  tabBackground: 'rgba(76, 125, 255, 0.05)',
  tabTextColor: 'rgba(31, 43, 77, 0.68)',
  tabActiveBorderColor: 'rgba(76, 125, 255, 0.24)',
  tabActiveBackground: 'rgba(76, 125, 255, 0.12)',
  headerIconColor: 'rgba(31, 43, 77, 0.82)',
  isStorlyn: false,
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
